const VIDEO_EXTENSIONS = {
  "video/mp4": "mp4",
  "video/webm": "webm",
};

export const normalizeVideoMimeType = (mimeType = "") => {
  const baseMimeType = mimeType.split(";", 1)[0].trim().toLowerCase();
  return VIDEO_EXTENSIONS[baseMimeType] ? baseMimeType : "";
};

export const getVideoExtension = (mimeType) =>
  VIDEO_EXTENSIONS[normalizeVideoMimeType(mimeType)] || "";
